import {
  Grid, Typography, Breadcrumbs, Link, Button, DialogContentText, DialogContent,
  DialogTitle, DialogActions, Dialog, List, ListItem, ListItemText, Table, TableBody, TableCell, TableRow, TableContainer, TableHead, Switch, FormControlLabel, Checkbox,
  TextField, Divider, CardHeader, Card, CardContent, CardContentTable, Paper, Tooltip, IconButton, Backdrop, Input, StepContent, StepLabel, Step, Stepper,
  InputAdornment
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import { useHistory } from 'react-router';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LockIcon from '@material-ui/icons/Lock';
import PollIcon from '@material-ui/icons/Poll';
import { confirmAlert } from 'react-confirm-alert';
import { green, red } from '@material-ui/core/colors';
import {
  getKoordinat,
  getUser,
} from 'src/utils/Common';
import { uploadFotograf } from 'src/utils/storage/StrPhoto';
import axios from 'src/utils/axios';
import customAxios from 'src/utils/customAxios';
import { setTask } from '../../store/actions/taskActions';
import PrintIcon from '@material-ui/icons/Print';
import Print from './Print';
import Follow from './Follow';
import CircularProgress from '@material-ui/core/CircularProgress';
import { getTasksRequest } from '../../store/actions';
import ForPartner from '../MaterialOrder2/Create/ForPartner';
import FindReplaceIcon from '@material-ui/icons/FindReplace';
import Substitution from './Substitution';
import Autocomplete from '@material-ui/lab/Autocomplete';
import SaveIcon from '@material-ui/icons/Save';
import AppReasonSearch from 'src/components/Selects/AppReasonSearch';
import MenuItem from '@material-ui/core/MenuItem';
import AddBoxRoundedIcon from '@material-ui/icons/AddBoxRounded';
import axiosHeadOffice from 'src/utils/axiosHeadOffice';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import DeleteIcon from '@material-ui/icons/Delete';
import TriageMaterialOrder from 'src/views/MaterialOrder2/Create/TriageMaterialOrder'
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import CloseIcon from '@material-ui/icons/Close';
import Hizmet from 'src/views/DefectsAndMaterials';
import RemoveShoppingCartIcon from '@material-ui/icons/RemoveShoppingCart';
import DeveloperBoardIcon from '@material-ui/icons/DeveloperBoard';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import CropFreeIcon from '@material-ui/icons/CropFree';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import ErrorDialog from "src/components/ErrorDialog";
import BarkodPopup from 'src/components/BarcodePopup';
const useStyles = makeStyles(theme => ({
  root: {},
  info: {
    marginTop: theme.spacing(0)
  },
  IconTop: {
    paddingTop: 0
  },
  submitButton: {
    marginTop: theme.spacing(2),
    width: '100%'
  },
  button: {
    marginTop: theme.spacing(1),
    width: '50%'
  },
  stepIcon: {
    "& .MuiStepIcon-root": {
      color: "#3B3030",
    },
    "& .MuiStepIcon-active": {
      color: "#3B3030",
    },
    "& .MuiStepIcon-completed": {
      color: "#3B3030",
    }
  },
  fields: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  },
  search: {
    flexGrow: 1,
    height: 42,
    padding: theme.spacing(0, 2),
    display: 'flex',
    alignItems: 'center'
  },
  searchIcon: {
    marginRight: theme.spacing(2),
    color: theme.palette.icon
  },
  searchInput: {
    flexGrow: 1
  },
  submitButtonWudaq: {
    marginTop: theme.spacing(0),
    width: '100%'
  },
}));



function Header({ className, ReceiptNo, tasks, Data,
  defectReducer,
  labourReducer,
  materialReducer, setTask, getTasksRequest }) {
  const classes = useStyles();
  const [durum, setDurum] = React.useState('');
  const [isButtonDisabled, setisButtonDisabled] = React.useState(false);
  const [isButtonDisabled3, setisButtonDisabled3] = React.useState(false);
  const [basvuruNedeni, setbasvuruNedeni] = React.useState('');
  const [FisHeader, setFisHeader] = useState([]);
  const [LoadingControl, setLoadingControl] = useState(false);
  const [uyari, setUyari] = useState(false);
  const [uyariTip, setUyariTip] = useState('success');
  const [sonDurum, setSonDurum] = useState('0');
  const [StatusData, setStatusData] = useState([]);
  const [statusCode, setStatusCode] = useState(0);
  const [rejectReason, setRejectReason] = useState('');
  //const [SFNumber, setSFNumber] = useState('');
  const SessionUser = getUser();
  const [Uyari1, setUyari1] = React.useState('');
  const [open, setOpen] = React.useState(false);
  const [WorkCase, setWorkCase] = React.useState('');
  const [PrintPopup, setPrintPopup] = React.useState(false);
  const [FollowPopup, setFollowPopup] = React.useState(false);
  const history = useHistory();
  const { t } = useTranslation('work_order');
  const [ClosePopupControl, setClosePopupControl] = useState(false);
  const [ClosePopupHeader, setClosePopupHeader] = useState('');
  const [CloseBtn1, setCloseBtn1] = useState('');
  const [CloseBtn2, setCloseBtn2] = useState('');
  const [UrgentCustomer, setUrgentCustomer] = useState(false);
  const [CloseTypePopupControl1, setCloseTypePopupControl1] = useState(0);
  const [CloseTypePopupControl2, setCloseTypePopupControl2] = useState(0);
  const [OpenResponse, setOpenResponse] = useState(false);
  const [ResponseData, setResponseData] = useState([]);
  const [error, setError] = useState(false);
  const [Required, setRequired] = useState(false);
  const [ManufacturingFault, setManufacturingFault] = useState('');
  const [compensation, setCompensation] = useState([]);
  const [responseMessage, setresponseMessage] = useState({
    ErrorCode: '0',
    ErrorDescription: t('success_message')
  });
  const [MaterialOrderId, setMaterialOrderId] = useState(0);
  const [OpenMaterialOrder, setOpenMaterialOrder] = useState(false);
  const isCancelledRef = useRef(false);
  const [OpenUsedNotUsedDialog, setOpenUsedNotUsedDialog] = useState(false);
  const [saveButtonDisabled, setSaveButtonDisabled] = useState(false)
  const [cloneArray, setCloneArray] = useState([])
  const [SubstitutionPopup, setSubstitutionPopup] = useState(false);
  const [FirstIssueType, setFirstIssueType] = useState(0);
  const [FirstType, setFirstType] = useState(0);
  const [IsLoanProductCountry, setIsLoanProductCountry] = useState(false);
  const [openCancellationPopup, setOpenCancellationPopup] = useState(false);
  const [CancellationReasonId, setCancellationReasonId] = useState({
    Id: 0,
    MainLanguageDescription: ''
  });
  const [CancellationNote, setCancellationNote] = useState('');
  const [cancellationReasonsData, setCancellationReasonsData] = useState([]);

  const [CopyWorkOrderPopup, setCopyWorkOrderPopup] = React.useState(false);
  const [openApproval, setOpenApproval] = React.useState(false);
  const [detail, setDetail] = React.useState(1)
  const [ServiceShopData, setServiceShopData] = useState([]);
  const [ServiceShopSelected, setServiceShopSelected] = useState(null);
  const [EmployeeId, setEmployeeId] = useState(0);
  const [ServiceShopId, setServiceShopId] = useState(0);
  const [IssueId, setIssueId] = useState(0);
  const search = '';
  const [newWorkCaseData, setNewWorkCaseData] = useState([]);
  const [ReferenceWorkOrderOpen, setReferenceWorkOrderOpen] = useState(false);
  const [isAdvancePrepaidAvailable, setIsAdvancePrepaidAvailable] = useState(false);
  const [advancePrepaidPopupOpen, setAdvancePrepaidPopupOpen] = useState(false);
  const [prepaidPaymentTypeId, setPrepaidPaymentTypeId] = useState('');
  const [prepaidCost, setPrepaidCost] = useState('');
  const [activePaymentTypeData, setActivePaymentTypeData] = useState([]);
  const [isSubmittingPrepaid, setIsSubmittingPrepaid] = useState(false);
  const [EmployeeData, setEmployeeData] = useState([]);
  const [ConsumerAddressId, setConsumerAddressId] = useState(0);
  const [defectsAndMaterials, setDefectsAndMaterials] = useState([]);
  const [defectAndMaterialList, setDefectAndMaterialList] = useState([]);
  const [OpenAIDialog, setOpenAIDialog] = useState(false);
  const [selectedDefect, setSelectedDefect] = useState(null);
  const [selectedMaterial, setSelectedMaterial] = useState(null);
  const [matchedPairs, setMatchedPairs] = useState([]);
  const [predictions, setPredictions] = useState([]);
  const [OpenTriageMaterialOrder, setOpenTriageMaterialOrder] = useState(false);
  const [IsAI, setIsAI] = useState(false)
  const [OrderNr, setOrderNr] = useState('');
  const [SoftwareDownloadOpen, setSoftwareDownloadOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [messageErrorDialog, setMessageErrorDialog] = React.useState('');
  const [openErrorDialog, setOpenErrorDialog] = React.useState(false);
  const [OpenBarkodCihaz, setOpenBarkodCihaz] = React.useState(false);
  const [DeviceBarcode, setDeviceBarcode] = React.useState('');
  const [response, setResponse] = React.useState("");
  const [activeStep, setActiveStep] = React.useState(0);
  const steps = getSteps();


  const SaveCancellation = CloseType => {
    const Data = {
      CancellationNote: CancellationNote,
      CancellationReasonId: CancellationReasonId?.Id,
    }
    handleMerkezeGonderEvet(Data, CloseType);
  }
  useEffect(() => {
    const current = Data;
    setFisHeader(current);
    if (current.length > 0) {
      setDurum(current[0].Status);
      setSonDurum(current[0].LatestStatus);
      setWorkCase(current[0].WorkCaseId);
      setbasvuruNedeni(current[0].IssueReason);
      setStatusCode(current[0].MobileStatusId);
      setRejectReason(current[0].RejectReason);
      //getSFNumber(current[0].WorkCaseId);
    }

    // eslint-disable-next-line
  }, [Data, tasks]);

  const getCompensation = () => {
    axios
      .get(
        `/GetCompensationSS/${ReceiptNo || 0}`
      )
      .then(response => {
        if (response.data.length > 0 && response.data != "") {
          setCompensation(response.data);
          setManufacturingFault(response.data[0].ManufacturingFault);
        } else {
          setCompensation([]); //no data
        }
      })
      .catch(error => {
        setUyariTip('error');
        setUyari(true);
      });
  };

  const getLoanProductCountry = () => {
    axios
      .get(
        `/GetLoanProductCountry/${parseInt(SessionUser.TenantId)}`
      )
      .then(response => {
        if (response.data == false) {
          setIsLoanProductCountry(false);
        } else {
          setIsLoanProductCountry(true);
        }
      })
      .catch(error => {
        setUyariTip('error');
        setUyari(true);
      });
  };

  const getAdvancePrepaidAvailability = () => {
    if (parseInt(SessionUser.TenantId) !== 75 || !ReceiptNo) return;
    const workOrderId = parseInt(ReceiptNo) || 0;
    const employeeId = parseInt(SessionUser?.TechnicianId || SessionUser?.EmployeeId) || 0;

    axios
      .get(`/GetAdvancePrepaidWorkorderAvailability/${workOrderId}/${employeeId}`)
      .then(response => {
        const availability =
          response.data?.[0]?.Availability ??
          response.data?.[0] ??
          response.data?.Availability ??
          response.data;

        setIsAdvancePrepaidAvailable(availability === 1 || availability === '1' || availability === true);
      })
      .catch(error => {
        setIsAdvancePrepaidAvailable(false);
      });
  };

  useEffect(() => {
    if (parseInt(SessionUser.TenantId) === 75 && ReceiptNo) {
      getAdvancePrepaidAvailability();
    }
  }, [ReceiptNo]);

  const GetActivePaymentTypes = () => {
    axios
      .get(`/GetActivePaymentTypes`)
      .then(response => {
        if (response.data && response.data.length > 0) {
          setActivePaymentTypeData(response.data);
        }
      })
      .catch(error => { });
  };

  const handleCreateAdvancePrepaidWorkOrder = () => {
    if (!prepaidPaymentTypeId) {
      setUyariTip('warning');
      setUyari(true);
      setOpen(true);
      setUyari1('Please select a Payment Type');
      return;
    }
    if (!prepaidCost || parseFloat(prepaidCost) <= 0) {
      setUyariTip('warning');
      setUyari(true);
      setOpen(true);
      setUyari1('Please enter a valid Cost');
      return;
    }

    setIsSubmittingPrepaid(true);
    const employeeId = parseInt(SessionUser?.TechnicianId || SessionUser?.EmployeeId) || 0;
    const payload = {
      WorkOrderId: parseInt(ReceiptNo) || 0,
      Detail: 0,
      IssueId: parseInt(IssueId) || 0,
      ServiceShopId: parseInt(ServiceShopId) || 0,
      EmployeeId: employeeId,
      PaymentTypeId: parseInt(prepaidPaymentTypeId) || 0,
      Cost: parseFloat(prepaidCost) || 0
    };

    axios
      .post('/CreateAdvancePrepaidWorkOrder', payload)
      .then(response => {
        setIsSubmittingPrepaid(false);
        let data = response.data;
        if (typeof data === 'string') {
          try { data = JSON.parse(data); } catch (e) { }
        }
        const responseData = Array.isArray(data) ? data[0] : data;
        if (responseData && (responseData.ErrorCode === 0 || responseData.ErrorCode === '0')) {
          setAdvancePrepaidPopupOpen(false);
          handleRouteWorkOrder(responseData.WorkOrderId);
        } else {
          setUyariTip('error');
          setUyari(true);
          setOpen(true);
          setUyari1(responseData ? (responseData.ErrorMessage || responseData.ErrorDescription || responseData.errorMessage) : 'Error occurred');
        }
      })
      .catch(error => {
        setIsSubmittingPrepaid(false);
        setUyariTip('error');
        setUyari(true);
        setOpen(true);
        setUyari1(error?.response?.data?.message || 'Error occurred while creating prepaid work order');
      });
  };

  useEffect(() => {
    getCompensation();
    getFirstIssueType();
    getLoanProductCountry();
    CancellationReasons();
  }, []);

  // const getSFNumber = (WorkCaseId) => {
  //   axios
  //     .get(
  //       `/GetSFNumber/${WorkCaseId || 0}`
  //     )
  //     .then(response => {
  //       if (response.data.length > 0 && response.data != "" && hasOnlyDigits(response.data)) {
  //         setSFNumber(response.data);
  //       }
  //       else {
  //         setSFNumber('');
  //       }
  //     })
  //     .catch(error => {
  //       setUyariTip('error');
  //       setUyari(true);
  //     });
  // };

  function hasOnlyDigits(value) {
    return /^-?\d+$/.test(value);
  }

  const handleCloseCancellationPopup = () => {
    setOpenCancellationPopup(false);
  };
  const handleClose = () => {
    setLoadingControl(true);
    axios
      .get(`/GetFirstIssueType/${ReceiptNo || 0}`)
      .then(response => {
        if (response.data.length > 0 && response.data != '') {
          if (FirstType == response.data[0].Type) {
            setSubstitutionPopup(false)
          }
          else {
            setSubstitutionPopup(false)
            history.push('/overview');
          }
        }
        setLoadingControl(false);
      })
      .catch(error => {
        setUyariTip('error');
        setUyari(true);
        setLoadingControl(false);
      });
  };

  const getFirstIssueType = () => {
    axios
      .get(`/GetFirstIssueType/${ReceiptNo || 0}`)
      .then(response => {
        if (response.data.length > 0 && response.data != '') {
          setFirstIssueType(response.data[0].ControlHeader);
          setFirstType(response.data[0].Type);
        } else {
          setFirstIssueType(0);
          setFirstType(0);
        }
      })
      .catch(error => {
        setUyariTip('error');
        setUyari(true);
      });
  };

  var SonlandirData = tasks.tasks.filter(d => parseInt(d.ReceiptNo) === parseInt(ReceiptNo));
  useEffect(() => {
    if (SonlandirData.length > 0) {
      duplcatingArray(SonlandirData[0].WorkOrderMaterials)
    }
  }, [SonlandirData[0]?.WorkOrderMaterials])
  //Used UnUsed Work Start
  const duplcatingArray = (datax) => {
    let itemArray = [];
    const change = datax?.map((data) => (
      Array.from({ length: data?.Count }, (v, i) => {
        itemArray.push(data)
      })
    ))

    const duplicatedArray = itemArray.map((item) => ({ ...item, is_selected: null }))
    setCloneArray(duplicatedArray)
  }
  function checkSelection({ index, value, id }) {
    const newValue = cloneArray.map((item, key) => {
      if (key === index) {
        item.is_selected = value;
      }
      return item;
    })
    setCloneArray(newValue);
  }
  const checkAll = () => {
    const updatedItems = cloneArray.map(item => ({
      ...item,
      is_selected: true,
    }));
    setCloneArray(updatedItems);
  };
  const clearUnusedItemsCheckBox = () => {
    const newValue = cloneArray.map((data) => ({ ...data, is_selected: null }))
    setCloneArray(newValue)
  }
  const handleSelectedUnusedItems = () => {
    let count = 0;
    cloneArray.map((data) => {
      if (data.is_selected === null) {
        count = 1
      }
    })

    if (count > 0 && OpenUsedNotUsedDialog) {
      setError(true)
    } else {
      setError(false)
      setOpenUsedNotUsedDialog(false)
      setOpenMaterialOrder(false)
      setClosePopupControl(true);
    }
  }
  //Used UnUsed Work End
  useEffect(() => {
    var UserTypeId = SessionUser.TechnicianId;
    var OldStatusId = sonDurum;
    axios
      .get(
        '/GetWorkOrderStatusLogic/' +
        OldStatusId +
        '/' +
        UserTypeId +
        '/' +
        ReceiptNo
      )
      .then(response => {
        const Deger = response.data;
        setStatusData(Deger);
        setIsAI(Deger.filter(i => i.StatusId == OldStatusId)[0].IsAI);
        setLoadingControl(false);
      })
      .catch(error => {
        setStatusData([]);
        setLoadingControl(false);
      });

  }, [SessionUser.ServiceShopId, sonDurum]);

  useEffect(() => {
    if (uyari)
      setisButtonDisabled3(false);
  }, [uyari]);

  const handleMerkezeGonderPopuplblOk = (event, CloseType, message) => {
    confirmAlert({
      message: message,
      buttons: [
        {
          label: t('lblOk'),
          onClick: () => {
            handleMerkezeGonderEvet(event, CloseType)
          }
        },

      ]
    });
  }

  const handleMerkezeGonderPopup0 = (event, CloseType) => {
    confirmAlert({
      message: t('Update_warning'),
      buttons: [
        {
          label: t('Evet'),
          onClick: () => {
            setSaveButtonDisabled(true)
            // if (SessionUser.TenantId == 37){
            //   handleMerkezeGonderEvet(event, CloseType)
            // }
            // else
            // {
            //   handleCheckSparePartsUsage(event, CloseType)
            // }
            handleMerkezeGonderEvet(event, CloseType)
            setSaveButtonDisabled(false)
          }
        },
        {
          label: t('Hayir'),
          onClick: () => { }
        }
      ]
    });
  }

  // handleMerkezeGonder means send SendToCenter which can be 
  // translated into like updateWorkOrder
  // we are updating the work order in with that function 
  // but first we are checking some data from the backend side
  const handleMerkezeGonder = (event, CloseType) => {
    const filteredData = tasks.tasks.filter(
      d => parseInt(d.ReceiptNo) === parseInt(ReceiptNo)
    );
    if (filteredData[0].IsStatusNoteRequired) {
      setresponseMessage({
        ErrorCode: 10,
        ErrorDescription: ('Status Note is Required.')
      });

      setUyariTip('error');
      setUyari(true);
      setOpen(true);
      setUyari1(('Status Note is Required.'));
      return;
    }
    duplcatingArray(SonlandirData[0].WorkOrderMaterials)
    getCompensation();
    const Data = tasks.tasks.filter(
      d => parseInt(d.ReceiptNo) === parseInt(ReceiptNo)
    );
    let job = Data[0];
    var sonDurum = job.LatestStatus;
    // Popup Controlü yapılıyor
    setisButtonDisabled3(false);
    setLoadingControl(true);

    axios
      .get(`/GetClosePopupControl/` + parseInt(sonDurum))
      .then(response => {
        if (parseInt(response.data) === 0) {
          handleMerkezeGonderPopup0(event, CloseType);
        }

        if (parseInt(response.data) === 1) {
          setClosePopupHeader(t('lblClosePopup1'));
          setCloseBtn1(t('lblCloseBtn1'));
          setCloseBtn2(t('lblCloseBtn2'));
          setCloseTypePopupControl1(1);
          setCloseTypePopupControl2(2);
          setClosePopupControl(true);
        }
        if (parseInt(response.data) === 2) {
          setClosePopupHeader(t('lblClosePopup2'));
          setCloseBtn1(t('lblCloseBtn5'));
          setCloseBtn2(t('lblCloseBtn6'));
          setCloseTypePopupControl1(5);
          setCloseTypePopupControl2(6);
          setClosePopupControl(true);
        }
        if (parseInt(response.data) === 3) {
          if (SonlandirData[0]?.WorkOrderMaterials?.length > 0 && SessionUser.TenantId != 37 && SessionUser.TenantId != 70 && SessionUser.TenantId != 75) {
            setOpenUsedNotUsedDialog(true);
          } else {
            setOpenUsedNotUsedDialog(false);
            setClosePopupControl(true)
            checkAll();
          }
          setClosePopupHeader(t('lblClosePopup3'));
          setCloseBtn1(t('lblCloseBtn3'));
          setCloseBtn2(t('lblCloseBtn4'));
          setCloseTypePopupControl1(3);
          setCloseTypePopupControl2(4);
          // setClosePopupControl(true);
        }
        setLoadingControl(false);
      })
      .catch(error => {
        setLoadingControl(false);
      });

  }
  //  handleCheckSparePartsUsage is being used by daniyal
  const handleCheckSparePartsUsage = async (event, CloseType) => {

    try {

      let job = Data[0];
      const MerkezeGonderilecekData = job;
      const data = [
        {

          Materials: MerkezeGonderilecekData.WorkOrderMaterials || [],


        }
      ];
      const config = {
        headers: { 'Content-Type': 'application/json' }
      };

      customAxios
        .post('/CheckSparePartsUsage', data[0].Materials, config)
        .then(response => {
          setLoadingControl(false);
          setClosePopupControl(false);

          if (response.data.toString().includes("No popup")) {
            handleMerkezeGonderEvet(event, CloseType)
          } else {
            handleMerkezeGonderPopuplblOk(event, CloseType, response.data);
          }

        })
        .catch(error => {
          setLoadingControl(false);
          setClosePopupControl(false);
          setresponseMessage({
            ErrorCode: 10,
            ErrorDescription: t('Offline_warning')
          });
          setUyariTip('error');
          setUyari(true);
        });

    } catch (error) {

    }

  }

  const handleMerkezeGonderEvet = async (event, CloseType) => {
    if (localStorage.getItem('UpdateButtonMaterialControl') !== undefined) {
      if (parseInt(localStorage.getItem('UpdateButtonMaterialControl')) === 0) {
        setUyariTip('error');
        setUyari(true);
        setOpen(true);
        setUyari1(t('lblButtonControlMaterial'));
        return;
      }
    }
    if (localStorage.getItem('UpdateButtonDefectControl') !== undefined) {
      if (parseInt(localStorage.getItem('UpdateButtonDefectControl')) === 0) {
        setUyariTip('error');
        setUyari(true);
        setOpen(true);
        setUyari1(t('lblButtonControlDefect'));
        return;
      }
    }
    if (localStorage.getItem('UpdateButtonLabourControl') !== undefined) {
      if (parseInt(localStorage.getItem('UpdateButtonLabourControl')) === 0) {
        setUyariTip('error');
        setUyari(true);
        setOpen(true);
        setUyari1(t('lblButtonControlLabour'));
        return;
      }
    }


    var MobileStatusId = StatusData?.filter(i => i.StatusId == sonDurum)[0]?.MobileStatusId

    if (MobileStatusId === undefined) {
      MobileStatusId = 1;
    }

    const Data = tasks.tasks.filter(
      d => parseInt(d.ReceiptNo) === parseInt(ReceiptNo)
    );

    let job = Data[0];
    const hizmetlerH = [];
    const isciliklerH = [];
    const malzemelerH = [];
    let iscilik_toplam = 0;
    let malzeme_toplam = 0;
    for (let h = 0; h < defectReducer.selected.length; h++) {
      const hizmet = defectReducer.selected[h];
      const hizmetRedux = defectReducer.defectsTable[hizmet];
      hizmetlerH.push({
        DefectId: hizmet,
        DefectCode: hizmetRedux?.UserCode,
        DefectDesc: hizmetRedux?.DefectDesc
      });
      const labourArray = labourReducer[hizmet];
      if (labourArray && labourArray.length > 0) {
        for (let i = 0; i < labourArray.length; i++) {
          const iscilik = labourReducer.Data.filter(
            d => d.LabourCode === labourArray[i]
          )[0];
          if (iscilik) {
            isciliklerH.push({
              LabourId: iscilik.LabourId,
              DefectId: hizmet,
              LabourCode: iscilik.LabourCode,
              LabourDesc: iscilik.LabourDesc,
              Price: iscilik.Price,
              PriceWithWat: iscilik.PriceWithWat,
              VatRate: iscilik.VatRate,
              VatId: iscilik.VatId,
              LabourPriceId: iscilik.PriceId
            });
            iscilik_toplam += iscilik.PriceWithWat
          }
        }
      }
      const materialArray = materialReducer[hizmet];
      if (materialArray && materialArray.length > 0) {
        for (let m = 0; m < materialArray.length; m++) {
          const malzeme = materialReducer.Data.filter(
            d => d.MaterialCode === materialArray[m]
          )[0];
          if (malzeme) {
            malzemelerH.push({
              MaterialId: malzeme.MaterialId,
              DefectId: hizmet,
              DefectDesc: hizmetRedux?.CategoryLevel1 + "/" + hizmetRedux?.CategoryLevel2 + "/" + hizmetRedux?.UserCode + "/" + hizmetRedux?.DefectDesc,
              MaterialCode: malzeme.MaterialCode,
              Count: materialReducer[malzeme.MaterialCode],
              MaterialDesc: malzeme.MaterialDesc,
              Price: malzeme.Price,
              PriceWithWat: malzeme.PriceWithWat,
              VatRate: malzeme.VatRate,
              VatId: malzeme.VatId,
              MaterialPriceListId: malzeme.PriceListId,
              MaterialPriceId: malzeme.PriceId
            });
            malzeme_toplam += materialReducer[malzeme.MaterialCode] * malzeme.PriceWithWat;
          }
        }
      }
    }
    // seçileni taska yaz
    job = {
      ...job,
      WorkOrderDetails: hizmetlerH,
      WorkOrderLabours: isciliklerH,
      WorkOrderMaterials: malzemelerH,
      EMploymentCostTotal: iscilik_toplam,
      MaterialTotal: malzeme_toplam
    };
    setTask(job);

    if (CloseType === 2) {
      setClosePopupControl(false);
      return;
    }
    if (CloseType === 4) {
      setClosePopupControl(false);
      return;
    }
    setisButtonDisabled3(true);
    try {
      setLoadingControl(true);
      const MerkezeGonderilecekData = job;
      const StatusId = parseInt(MerkezeGonderilecekData.LatestStatus);
      const StatusLatitude = getKoordinat('Enlem');
      const StatusLongitude = getKoordinat('Boylam');
      const Control = MerkezeGonderilecekData.MobileStatusId;
      if (!MerkezeGonderilecekData.noAppointmentDate) {

        // Specific Romanian Rule
        // If Repair Completed Status in Serbia is Repair Completed
        // And Status Note is empty then it will throw an error
        if (StatusId === 664 && (job.StatusNote == '' || job.StatusNote == undefined)) {
          setresponseMessage({
            ErrorCode: 10,
            ErrorDescription: t('Special Serbia Error, you need to fill Status Note')
          });
          setUyariTip('error');
          setUyari(true);
          setOpen(true);
          setUyari1(t('Please fill Status Note'));
          return;
        }

        if (IsAI === true) {
          AIPrediction();
          setOpenAIDialog(true);
          return;
        }

        // if (MobileStatusId == 21 && (parseInt(MerkezeGonderilecekData.AppointmentDate) || null) === null) {
        //   //At Technician ama Appointment Date Boş
        //   setresponseMessage({
        //     ErrorCode: 10,
        //     ErrorDescription: t('lblSelectAppointmentDate')
        //   });
        //   setUyariTip('error');
        //   setUyari(true);
        //   setOpen(true);
        //   setUyari1(t('lblSelectAppointmentDate'));
        //   return;
        // }
      }
      if (MobileStatusId == 24 && (parseInt(MerkezeGonderilecekData.AppointmentDate) || null) === null) {
        //Appointment made ama Appointment Date Boş
        setresponseMessage({
          ErrorCode: 10,
          ErrorDescription: t('lblAppointmentDateSelect')
        });
        setUyariTip('error');
        setUyari(true);
        setOpen(true);
        setUyari1(t('lblAppointmentDateSelect'));
        return;
      }


      if (MobileStatusId == 3 && (parseInt(MerkezeGonderilecekData.ConsumerAddressId) || 0) === 0) {
        //Assigned ama Adres boş
        setresponseMessage({
          ErrorCode: 10,
          ErrorDescription: t('lblAppointmentAddress')
        });
        setUyariTip('error');
        setUyari(true);
        setOpen(true);
        setUyari1(t('lblAppointmentAddress'));
        return;
      }
      if (CloseType === 5) {
        setClosePopupControl(false);
        setOpenCancellationPopup(true);
        return;
      }
      if (CloseType === 8) {
        const dataBody = {
          WorkCaseId: parseInt(MerkezeGonderilecekData.WorkCaseId) || 0,
          CancellationNote: event?.CancellationNote,
          CancellationReasonId: event?.CancellationReasonId,
        }
        const dataConfigCancellation = {
          headers: { 'Content-Type': 'application/json' }
        };
        axios
          .post('/SetWorkCaseCancellation', dataBody, dataConfigCancellation)
          .then(response => {
            const res = response.data.length === 0 ? [] : response.data;
            if (res[0].ErrorCode === 0) {
              setresponseMessage({
                ErrorCode: 10,
                ErrorDescription: t('success_message')
              });
              setUyariTip('success');
              setUyari(true);
              setOpenCancellationPopup(false);
            }
          })
          .catch(error => {
            setresponseMessage({
              ErrorCode: 10,
              ErrorDescription: t('lblErrorMessage')
            });
            setUyariTip('error');
            setUyari(true);
          });
      }

      if (CloseType === 3) {
        let filterWorkOrderMaterials = []

        MerkezeGonderilecekData.WorkOrderMaterials.forEach((mrow, index) => {
          let Count = 0;
          let CountMaterial = 0
          cloneArray.forEach((irow, iindex) => {
            if (mrow.DefectId === irow.DefectId && mrow.MaterialId === irow.MaterialId && irow.is_selected === true) {
              Count++;
              CountMaterial++
            }
          })
          if (CountMaterial == 0) {
            delete materialReducer[mrow.MaterialCode]

            const selected = materialReducer[mrow.DefectId]
            const deleteIndex = selected.indexOf(mrow.MaterialCode)
            materialReducer[mrow.DefectId].splice(deleteIndex, 1)
          } else {
            materialReducer[mrow.MaterialCode] = CountMaterial
            CountMaterial = 0;
          }
          if (Count > 0) {
            filterWorkOrderMaterials.push({
              Count: Count,
              DefectId: mrow.DefectId,
              DefectDesc: mrow.DefectDesc,
              MaterialCode: mrow.MaterialCode,
              MaterialDesc: mrow.MaterialDesc,
              MaterialId: mrow.MaterialId,
              MaterialPriceId: mrow.MaterialPriceId,
              MaterialPriceListId: mrow.MaterialPriceListId,
              Price: mrow.Price,
              PriceWithWat: mrow.PriceWithWat,
              VatId: mrow.VatRateId,
              VatRate: mrow.VatRate
            })
          }
        })
        MerkezeGonderilecekData.WorkOrderMaterials = filterWorkOrderMaterials
      }



      // if (MobileStatusId == 11 && MerkezeGonderilecekData.PotentialLiabiltiy == 1 && ManufacturingFault == '') {
      //   //Selected New Visit Required and click potential liability claim but compensation form is empty
      //   //(we can understand if manufacturingfault is empty then compensation form is not filled because it is a mandatory)
      //   setresponseMessage({
      //     ErrorCode: 10,
      //     ErrorDescription: t('lblCompensationError')
      //   });
      //   setUyariTip('error');
      //   setUyari(true);
      //   setOpen(true);
      //   setRequired(true);
      //   setUyari1(t('lblCompensationError'));
      //   return;
      // }


      if (MerkezeGonderilecekData.FormRequired == 1 && ManufacturingFault == '') {
        //If FormRequired is true but compensation form is empty.
        //(we can understand if manufacturingfault is empty then compensation form is not filled because it is a mandatory)
        setresponseMessage({
          ErrorCode: 10,
          ErrorDescription: t('lblCompensationError')
        });
        setUyariTip('error');
        setUyari(true);
        setOpen(true);
        setRequired(true);
        setUyari1(t('lblCompensationError'));
        return;
      } else {
        if (MobileStatusId == 9 && MerkezeGonderilecekData.Confirmed == 0) {
          //You cannot update if the form is mandatory and not confirmed.
          setresponseMessage({
            ErrorCode: 10,
            ErrorDescription: t('lblConfirmedError')
          });
          setUyariTip('error');
          setUyari(true);
          setOpen(true);
          setRequired(true);
          setUyari1(t('lblConfirmedError'));
          return;
        }
      }

      const data = [
        {
          WorkOrderId: parseInt(MerkezeGonderilecekData.ReceiptNo) || 0,
          WorkCaseId: parseInt(MerkezeGonderilecekData.WorkCaseId) || 0,
          ServiceShopId: parseInt(MerkezeGonderilecekData.ServiceShopId) || 0,
          ConsumerId: parseInt(MerkezeGonderilecekData.ConsumerId) || 0,
          ConsumerAddressId: parseInt(MerkezeGonderilecekData.ConsumerAddressId) || 0,
          ContactName: MerkezeGonderilecekData.ContactName || '',
          ContactPhone: MerkezeGonderilecekData.ContactPhone || '',
          EmployeeId: parseInt(MerkezeGonderilecekData.EmployeeId) || 0,
          ModelCode: MerkezeGonderilecekData.ModelCode || '',
          ProductionYear: parseInt(MerkezeGonderilecekData.ProductionYear) || 0,
          ProductionMonth: parseInt(MerkezeGonderilecekData.ProductionMonth) || 0,
          SerialNumber: MerkezeGonderilecekData.SerialNumber || '0',
          AttributeId: parseInt(MerkezeGonderilecekData.AttributeId) || 0,
          WarrantyDate: MerkezeGonderilecekData.WarrantyDate || '',
          WarrantyTypeId: parseInt(MerkezeGonderilecekData.WarrantyTypeId) || 0,
          LatestStatus: parseInt(MerkezeGonderilecekData.LatestStatus) || 4,
          OperationPlaceId: parseInt(MerkezeGonderilecekData.OperationPlaceId) || 0,
          Notes: MerkezeGonderilecekData.Notes || '',
          StatusLatitude: StatusLatitude || '',
          StatusLongitude: StatusLongitude || '',
          IssueId: MerkezeGonderilecekData.IssueId || '',
          RetailerId: MerkezeGonderilecekData.RetailerId || 0,
          PaymentTypeId: parseInt(MerkezeGonderilecekData.PaymentTypeId) || 0,
          ReworkId: parseInt(MerkezeGonderilecekData.ReworkId) || 0,
          RefurbishmentId: parseInt(MerkezeGonderilecekData.RefurbishmentId || 0),
          DiscountAmountTotal: MerkezeGonderilecekData.DiscountAmountTotal || 0,
          ProjectCode: MerkezeGonderilecekData.ProjectCode || '',
          ...(SessionUser.TenantId == 75 ? {
            CustomerErrorCode: MerkezeGonderilecekData.CustomerErrorCode || '',
            ServiceErrorCode: MerkezeGonderilecekData.ServiceErrorCode || ''
          } : {}),
          UpdateUserId: parseInt(SessionUser.TechnicianId) || 0,
          CloseType,
          ChannelId: parseInt(MerkezeGonderilecekData.ChannelId) || 1,
          AppointmentDate: MerkezeGonderilecekData.AppointmentDate || '',
          AppointmentEndDate: MerkezeGonderilecekData.AppointmentEndDate || '',
          UrgentCustomer: MerkezeGonderilecekData.UrgentCustomer || 0,
          PotentialLiabiltiy: MerkezeGonderilecekData.PotentialLiabiltiy || 0,
          NoInvoice: MerkezeGonderilecekData.NoInvoice || false,
          SourceOfDefect: MerkezeGonderilecekData.SourceOfDefect || 0,
          PriorityId: parseInt(MerkezeGonderilecekData.PriorityId) || 1,
          PreferredDate: MerkezeGonderilecekData.PreferredDate || '',
          Defects: (MerkezeGonderilecekData.WorkOrderDetails || []).map(h => { return { DefectId: h.DefectId }; }) || [],
          Labours: MerkezeGonderilecekData.WorkOrderLabours || [],
          Materials: MerkezeGonderilecekData.WorkOrderMaterials || [],
          DistributorId: MerkezeGonderilecekData.DistributorId || 0,
          TaskTypeId: MerkezeGonderilecekData.TaskTypeId || 0,
          Barcode: MerkezeGonderilecekData.Barcode || '',
          UsedNotUsedMaterialData: cloneArray || [],
          DiscountTypeId: MerkezeGonderilecekData.DiscountTypeId || 0,
          DiscountRateId: MerkezeGonderilecekData.DiscountRateId || 0,
          BillingConsumer: MerkezeGonderilecekData.BillingConsumer || [],
        }
      ];
      const config = {
        headers: { 'Content-Type': 'application/json' }
      };

      axios
        .post('/SetWorkOrderUpdate', data, config)
        .then(response => {
          setLoadingControl(false);
          setClosePopupControl(false);
          const ResponseData = response.data[0];
          if (parseInt(ResponseData.ErrorCode) !== 0) {
            setOpenResponse(true);
            setResponseData(ResponseData.ErrorDescription.split('|'));
          } else {
            getTasksRequest(parseInt(MerkezeGonderilecekData.ReceiptNo));
            setisButtonDisabled(true);
            setresponseMessage({
              ErrorCode: 0,
              ErrorDescription: ResponseData.ErrorDescription
            });
            setUyariTip('success');
            setUyari(true);
            setOpen(true);
            setUyari1(ResponseData.ErrorDescription);
            if (ResponseData?.OrderId > 0) {
              setMaterialOrderId(ResponseData?.OrderId);
              isCancelledRef.current = false;
              setOpenMaterialOrder(true);
            } else {
              setMaterialOrderId(0);
              setOpenMaterialOrder(false);
            }
            setTimeout(() => setisButtonDisabled(false), 5000);
            setisButtonDisabled3(false);

          }
        })
        .catch(error => {
          setLoadingControl(false);
          setClosePopupControl(false);
          setresponseMessage({
            ErrorCode: 10,
            ErrorDescription: t('Offline_warning')
          });
          setUyariTip('error');
          setUyari(true);
        });
    } catch (error) {
      setLoadingControl(false);
      setClosePopupControl(false);
      setresponseMessage({
        ErrorCode: 10,
        ErrorDescription: t('Offline_warning')
      });
      setUyariTip('error');
      setUyari(true);
    }
  };
  const CancellationReasons = () => {
    axios
      .get(`/GetCancellationReasons`)
      .then(response => {
        if (response.data.length > 0) {
          setCancellationReasonsData(response.data);

        }
      })
      .catch(error => { });
  };

  function GetMaterialOrderSAPCountry() {
    axios
      .post('/GetMaterialOrderSAPCountry/' + SessionUser.TenantId)
      .then(response => {
        if (response.data) {
          if (OrderNr !== '' && OrderNr !== undefined) {
            CreateOrderInSap(OrderNr);
          } else {
            CreateOrderInSap(MaterialOrderId);
          }
        }
      });
  }

  function CreateOrderInSap(MaterialOrderId) {
    axios
      .post('/CreateOrderInSAP/' + MaterialOrderId)
      .then(response => {
        if (response.data.ErrorCode == 1000) {
          setresponseMessage({
            ErrorCode: response.data.ErrorCode,
            ErrorDescription: response.data.ErrorMessage
          });
          setUyariTip('error');
          setUyari(true);
          setOpen(true);
          setUyari1(responseMessage.ErrorDescription);
          return;
        }
      });
  }

  function handleCloseDialog() {
    setOpenMaterialOrder(false);
    if (SessionUser.TenantId != 64 && !isCancelledRef.current) {
      GetMaterialOrderSAPCountry();
    }
  }


  const SetCopyWorkOrder = (detail) => {
    handleCloseApproval();
    setCopyWorkOrderPopup(false);
    var employeeId = EmployeeId ? EmployeeId : SessionUser.TechnicianId;
    axios
      .post('/SetCopyWorkOrder/' + ReceiptNo + '/' + detail + '/' + IssueId + '/' + (parseInt(SessionUser.TenantId) === 75 ? 0 : ServiceShopId) + '/' + (parseInt(SessionUser.TenantId) === 75 ? 0 : employeeId))
      .then(response => {
        var ResponseData = response.data && response.data[0];
        if (ResponseData && ResponseData.ErrorCode == 0) {
          setReferenceWorkOrderOpen(false);
          handleRouteWorkOrder(ResponseData.WorkOrderId);
        } else {
          setUyariTip('error');
          setUyari(true);
          setOpen(true);
          setUyari1(ResponseData ? (ResponseData.errorMessage || ResponseData.ErrorMessage) : 'Error occurred');
        }
      })
      .catch(error => { });
  }

  const handleRouteWorkOrder = (WorkOrderId) => {
    sessionStorage.removeItem('WorkOrderId');
    sessionStorage.setItem('WorkOrderId', WorkOrderId);
    getTasksRequest(WorkOrderId);
    history.push(`/WorkOrder/${WorkOrderId}/summary`);
  }

  const handleCloseApproval = () => {
    setOpenApproval(false);
  };

  const handleOpenApproval = (detailData) => {
    setDetail(detailData);
    setOpenApproval(true);
  }

  const handleChangeServiceShopId = value => {
    setServiceShopSelected(value);
    setServiceShopId(value.Id);
    GetSchedulingEmployee(value.Id);
    let job = SonlandirData[0];
    job = {
      ...job,
      ServiceShopId: value.Id
    };
    setTask(job);
  };

  const GetSchedulingEmployee = ServiceShopId => {
    setEmployeeData([]);
    setEmployeeId('');
    axios
      .get(`/GetSchedulingEmployee/${ServiceShopId}`)
      .then(response => {
        if (response.data.length > 0) {
          var EmloyeeList = response.data;
          setEmployeeData(EmloyeeList);
          if (SonlandirData[0]?.EmployeeId || 0 > 0) {
            setEmployeeId(SonlandirData[0]?.EmployeeId);
          }
        }
      })
      .catch(error => { });
  };

  const GetSchedulingServiceShop = (ConsumerId, AddressId) => {
    setServiceShopData([]);
    setServiceShopId('');
    axios
      .get(`/GetSchedulingServiceShop/${ConsumerId}/${AddressId}/${ReceiptNo}/${SessionUser.Role}`)
      .then(response => {
        if (response.data.length > 0) {
          var ServiceShopList = response.data;
          setServiceShopData(ServiceShopList);
          if (ServiceShopList.length === 1 && parseInt(SonlandirData[0]?.ServiceShopId || 0) < 1) {
            setServiceShopId(ServiceShopList[0].Id);
            GetSchedulingEmployee(ServiceShopList[0].Id);
            return;
          }
          if (parseInt(SonlandirData[0]?.ServiceShopId || 0) > 0) {
            setServiceShopId(SonlandirData[0]?.ServiceShopId);
            var ServisData = ServiceShopList.filter(x => x.Id === SonlandirData[0]?.ServiceShopId);
            setServiceShopSelected(ServisData[0]);
            GetSchedulingEmployee(SonlandirData[0]?.ServiceShopId);
          }
        }
      })
      .catch(error => { });
  };

  useEffect(() => {
    if (SonlandirData[0]?.ConsumerId && SonlandirData[0]?.ConsumerAddressId) {
      GetSchedulingServiceShop(
        SonlandirData[0].ConsumerId,
        SonlandirData[0].ConsumerAddressId
      );
      setConsumerAddressId(SonlandirData[0].ConsumerAddressId);
    }
  }, [SonlandirData[0]?.ConsumerId]);

  const handleChangeEmployeeId = event => {
    setEmployeeId(event.target.value);
    let job = SonlandirData[0];
    job = {
      ...job,
      EmployeeId: event.target.value
    };
    setTask(job);
  };

  const handleChangeIssueId = value => {
    setIssueId(value.Id);
    let job = { ...SonlandirData[0] };
    job.IssueId = value.Id;
    job.Issue = value.Dsc;
    setTask(job);
    setNewWorkCaseData(job);
  }

  async function AIPrediction() {
    setLoadingControl(true);
    var row = SonlandirData[0];

    const predictionRequest = {
      BASVURU_NEDENI: row.IssueReason,
      BASVURU_NOTU: row.CallCenterNote === null ? '' : row.CallCenterNote,
      FIS_NO: row.ReceiptNo,
      MODEL_KODU: row.MappingModelCode,
      SF_ACIKLAMA: ""
    };

    axiosHeadOffice
      .post('/AIPrediction', predictionRequest)
      .then(result => {
        var response = result.data.Response;
        var responsePredictions = result.data.TAHMINLER;

        if (response.ErrorCode !== '1000') {
          setPredictions(responsePredictions);
          AIDefectsAndMaterials(responsePredictions);
        } else {
          setPredictions([]);
          setresponseMessage({
            ErrorCode: response.ErrorCode,
            ErrorDescription: response.ErrorDescription
          });
        }
      });
    setLoadingControl(false);
  }

  async function AIDefectsAndMaterials(predictions) {
    setDefectsAndMaterials([]);
    setLoadingControl(true);

    const DefectCodes = predictions.map(p => p.HIZMET_KODU);
    const MaterialCodes = predictions.map(p => p.MALZEME_KODU);

    const data = {
      HIZMET_KODU: DefectCodes,
      MALZEME_KODU: MaterialCodes
    };

    axiosHeadOffice
      .post('/GetAIPredictionDefectAndMaterial', data)
      .then(values => {
        if (values.data?.length > 0) {
          var filteredData = values.data;
          setDefectsAndMaterials(filteredData.map((d) => ({
            DefectId: d.DefectId,
            DefectCode: d.DefectCode,
            Defect: d.Defect,
            CategoryLevel2: d.CategoryLevel2,
            DefectType: d.DefectType,
            DefectTypeCode: d.DefectTypeCode,
            MaterialId: d.MaterialId,
            MaterialCode: d.MaterialCode,
            MaterialDsc: d.MaterialDsc
          })));
        } else {
          setDefectsAndMaterials([]);
        }
      });
    setLoadingControl(false);
  }

  function TriagePreorderOperations(isOrder) {
    setLoadingControl(true);

    const data = matchedPairs.length > 0 ? matchedPairs.map(pair => ({
      WorkOrderId: ReceiptNo.includes(" ") ? ReceiptNo.trim() : ReceiptNo,
      DefectId: pair.defect.DefectId,
      MaterialId: pair.material.MaterialId,
      IsOrder: isOrder,
      EmployeeId: SessionUser.TechnicianId
    })) :
      [{
        WorkOrderId: ReceiptNo.includes(" ") ? ReceiptNo.trim() : ReceiptNo,
        DefectId: 0,
        MaterialId: 0,
        IsOrder: isOrder,
        EmployeeId: SessionUser.TechnicianId
      }];


    axiosHeadOffice
      .post('/TriagePreorderOperations', data)
      .then(response => {
        if (response.data.ErrorCode === "0") {
          setOpen(true);
          setUyari1(t('lblSuccess') + ' - ' + response.data.ErrorDescription);
          setOpenAIDialog(false);
          getTasksRequest(parseInt(SonlandirData[0].ReceiptNo));
        }
        else if (response.data.ErrorCode === "10") {
          setOpen(true);
          setUyari1(isOrder ? t('lblTriageOperationMsg') : t('lblWithoutOrderTip'));
          setOpenAIDialog(false);
          getTasksRequest(parseInt(SonlandirData[0].ReceiptNo));
        }
        else if (response.data.ErrorCode === "1000") {
          setOpen(true);
          setUyari1(response.data.ErrorDescription);
        }
      });
    setLoadingControl(false);
  }

  const handleDefectSelect = (defect) => {
    setSelectedDefect(defect);
    setSelectedMaterial(null);
  };

  const handleMaterialSelect = (material) => {
    setSelectedMaterial(material);
  };

  const handleMatch = () => {
    if (selectedDefect && selectedMaterial) {
      setMatchedPairs([...matchedPairs, { defect: selectedDefect, material: selectedMaterial }]);
      setSelectedDefect(null);
      setSelectedMaterial(null);
    }
  };

  const handleDeleteMatchedPair = (index) => {
    const updatedMatchedPairs = [...matchedPairs];
    updatedMatchedPairs.splice(index, 1);
    setMatchedPairs(updatedMatchedPairs);
  };


  function GetDefectsAndMaterialsByWorkOrderId() {
    setLoadingControl(true);

    axiosHeadOffice
      .get('/GetDefectsAndMaterialsByWorkOrderId/' + ReceiptNo)
      .then(response => {
        if (response.data.length > 0) {
          setDefectAndMaterialList(response.data);
        } else {
          setDefectAndMaterialList([]);
        }
      });
    setLoadingControl(false);
  }

  useEffect(() => {
    if (OpenAIDialog === true)
      GetDefectsAndMaterialsByWorkOrderId();
  }, [OpenAIDialog]);


  function handleAddMatchedPairs(newDefect, newMaterial) {
    if (newDefect !== undefined) {
      setMatchedPairs([...matchedPairs, {
        defect: { Defect: newDefect.DefectDesc, DefectCode: newDefect.UserCode, DefectId: newDefect.Code },
        material: { MaterialCode: newMaterial.MaterialCode, MaterialDsc: newMaterial.MaterialDesc, MaterialId: newMaterial.MaterialId }
      }]);
    }
  }

  const hasMaterialAndDefect = matchedPairs.some(pair => pair.material && pair.defect);

  const getOrderNr = (orderNr) => {
    if (orderNr !== undefined) {
      setOrderNr(orderNr);
    }
  };

  const handleCloseTriageMaterialOrder = () => {
    if (OrderNr === '' || OrderNr === undefined) {
      setOpen(true);
      setUyari1(t('lblObligationOrderMsg'));
    } else {
      setOpenTriageMaterialOrder(false);
      if (SessionUser.TenantId != 64) {
        GetMaterialOrderSAPCountry();
      }
    }
  };

  function getSteps() {
    return [t('lblProductInfo'),
    t('lblDeviceInfo')];
  }

  function getStepContent(step) {
    switch (step) {
      case 0:
        return (
          <div>
            <Typography className={classes.title} color="textSecondary">
              {t('lblBarkod')}
            </Typography>
            <Typography variant="h6" component="h2" gutterBottom>
              {SonlandirData[0]?.Barcode}
            </Typography>
            <Typography className={classes.title} color="textSecondary">
              {t('lblModelCode')}
            </Typography>
            <Typography variant="h6" component="h2" gutterBottom>
              {SonlandirData[0]?.ModelCode}
            </Typography>
            <Typography className={classes.title} color="textSecondary">
              {t('Urun')}
            </Typography>
            <Typography variant="h6" component="h2" gutterBottom>
              {SonlandirData[0]?.Model}
            </Typography>
            <Typography className={classes.title} color="textSecondary">
              {t('input_uyil')}
            </Typography>
            <Typography variant="h6" component="h2" gutterBottom>
              {SonlandirData[0]?.ProductionYear}
            </Typography>
            <Typography className={classes.title} color="textSecondary">
              {t('input_udonem')}
            </Typography>
            <Typography variant="h6" component="h2" gutterBottom>
              {SonlandirData[0]?.ProductionMonth}
            </Typography>
            <Typography className={classes.title} color="textSecondary">
              {t('input_serino')}
            </Typography>
            <Typography variant="h6" component="h2" gutterBottom>
              {SonlandirData[0]?.SerialNumber}
            </Typography>
          </div>
        );
      case 1:
        return (
          <div className={classes.fields}>
            <Paper
              className={classes.search}
              elevation={1}
            >
              <CropFreeIcon
                onClick={handleCihazBarkodOpen}
                className={classes.searchIcon}
              />
              <Input
                className={classes.searchInput}
                disableUnderline
                value={DeviceBarcode}
                onChange={(event) => { setDeviceBarcode(event.target.value); }}
                placeholder={t('lblDeviceBarcode')}
              />
            </Paper>
          </div>
        );
      default:
        return '';
    }
  }

  const handleNext = () => {
    if (activeStep !== steps.length - 1) {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
      return;
    }
    let user = getUser();
    let body = {
      UserName: user.UserId || '',
      BonaDeviceCode: DeviceBarcode || '',
      ModelCode: SonlandirData[0].ModelCode || '',
      ProductBarcode: SonlandirData[0].Barcode || '',
      WorkOrderId: SonlandirData[0].ReceiptNo || 0
    }
    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    setLoading(true);

    axios.post('/BonaDataCollection', body, config)
      .then(res => {
        setResponse(res.data.message);
        setLoading(false);
        setActiveStep(steps.length);
      }).catch(err => {
        setResponse(err.message);
        setLoading(false);
        setActiveStep(steps.length);
      });
  };

  const handleCihazBarkodClose = async (barkod) => {
    setDeviceBarcode(barkod);
    setOpenBarkodCihaz(false);
  };

  const GetBonaPdfData = async () => {
    const getFormattedFileName = () => {
      const date = new Date().toLocaleDateString('tr-TR', { year: 'numeric', month: '2-digit', day: '2-digit' }).replace(/[/]/g, '-');
      return `${SonlandirData[0].Barcode}_${date}.pdf`;
    };

    try {
      setLoading(true);
      const WorkOrderId = ReceiptNo;

      const response = await axios.get(`/download-pdf?WorkOrderId=${WorkOrderId}`, { responseType: 'blob' });

      const reader = new FileReader();
      reader.onload = () => {
        try {
          const result = reader.result;
          if (typeof result === 'string' && result.startsWith('{')) {
            const errorData = JSON.parse(result);
            setMessageErrorDialog(`${t('lblErrorPdf')}: ${errorData.title} - ${errorData.status}`);
            setOpenErrorDialog(true);
          } else {
            const file = new Blob([response.data], { type: 'application/pdf' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(file);

            link.download = getFormattedFileName();

            link.click();
            URL.revokeObjectURL(link.href);
          }
        } catch (error) {
          const file = new Blob([response.data], { type: 'application/pdf' });
          const link = document.createElement('a');
          link.href = URL.createObjectURL(file);

          link.download = getFormattedFileName();

          link.click();
          URL.revokeObjectURL(link.href);
        }
      };

      reader.readAsText(response.data);
    } catch (error) {
      const errorMessage = error.response?.data
        ? `${t('lblErrorPdf')}: ${error.response.data.title} - ${error.response.data.status}`
        : `${t('lblErrorPdf')}: ${error.message}`;
      setMessageErrorDialog(errorMessage);
      setOpenErrorDialog(true);
    } finally {
      setLoading(false);
    }
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  const handleCihazBarkodOpen = () => {
    setOpenBarkodCihaz(true);
  };

  return !FisHeader[0] ? (
    <></>
  ) : (
    <Grid container direction="row" style={{ justifyContent: "space-between" }} alignItems="center">
      <Grid item xs={12} sm={3} lg={3} align="center">
        <Breadcrumbs aria-label="breadcrumb">
          <Link color="inherit">Sirius</Link>
          <RouterLink to="/overview">{t('Musteri')}</RouterLink>
          <Typography color="textPrimary">{t('lblWorkOrderDetail')}</Typography>
        </Breadcrumbs>
      </Grid>
      <Grid item xs={12} sm={4} lg={4} align="center">
        <Typography variant="h6" gutterBottom>
          {FisHeader[0].CustomerFullName} - {durum} -
          {' '}
          {statusCode === 7 ? t('lblRejectReason') + ': ' + rejectReason + ' - ' : ''}
          {basvuruNedeni + ' - ' + t('lblWo', 'WO') + ': ' + FisHeader[0].ReceiptNo + ' - ' + t('lblWc', 'WC') + ': ' + FisHeader[0].WorkCaseId}
          {/* {SFNumber == '' ? '' : ' - SF: ' + SFNumber} */}
          {FisHeader[0]?.MaterialOrderId === 0 ? '' : ' - ' + t('lblMaterialOrderId') + ': ' + FisHeader[0]?.MaterialOrderId}
        </Typography>
      </Grid>
      <Grid item xs={12} sm={5} lg={5}>
        <Grid container spacing={1} justify="flex-end" alignItems="center">
          {(IsLoanProductCountry || parseInt(SessionUser.TenantId) === 75) && (
            <Grid item>
              <Button
                aria-controls="customized-menu"
                aria-haspopup="true"
                variant="contained"
                color="primary"
                onClick={() => {
                  if (parseInt(SessionUser.TenantId) === 75) {
                    getAdvancePrepaidAvailability();
                  }
                  setCopyWorkOrderPopup(true);
                }}
              >
                {t('lblOperations')}
              </Button>
            </Grid>
          )}

          {!SessionUser.IsIhpTenant && (
            <Grid item>
              <Button
                variant="contained"
                color="primary"
                onClick={() => setFollowPopup(true)}
                endIcon={<PollIcon />}
                style={{ backgroundColor: FisHeader[0].Follow === 1 ? green[500] : '' }}
                disabled={FisHeader[0].Follow === 1}
              >
                {t('lblFollow')}
              </Button>
            </Grid>
          )}

          <Grid item>
            <Button
              variant="contained"
              color="primary"
              onClick={() => setPrintPopup(true)}
              endIcon={<PrintIcon />}
            >
              {t('lblPrint')}
            </Button>
          </Grid>

          <Grid item>
            <Button
              variant="contained"
              color="primary"
              disabled={isButtonDisabled}
              onClick={e => handleMerkezeGonder(e, 0)}
              endIcon={<LockIcon />}
            >
              {t('lblUpdate')}
            </Button>
          </Grid>
        </Grid>
      </Grid>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">
          {t('Bilgilendirme')}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {Uyari1}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)} color="primary">
            {t('Tamam')}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openApproval}
        onClose={handleCloseApproval}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {detail == 1 ? t('lblWithDetailWorkOrder') : detail == 2 ? t('lblWarrantyExpenseWorkOrder') : t('lblWithoutDetailWorkOrder')}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseApproval} color="primary">
            {t('iptal')}
          </Button>
          <Button onClick={() => SetCopyWorkOrder(detail)} color="primary" autoFocus>
            {t('lblContinue')}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={CopyWorkOrderPopup}
        onClose={() => setCopyWorkOrderPopup(false)}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">
          {t('lblOperations')}
        </DialogTitle>
        <Divider />
        <DialogContent>
          {parseInt(SessionUser.TenantId) === 75 ? (
            <div>
              <Button
                variant="contained"
                color="primary"
                className={classes.submitButton}
                onClick={() => setReferenceWorkOrderOpen(true)}
              >
                {t('lblReferenceWorkOrder')}
              </Button>
              {isAdvancePrepaidAvailable && (
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.submitButton}
                  onClick={() => {
                    setCopyWorkOrderPopup(false);
                    GetActivePaymentTypes();
                    setPrepaidPaymentTypeId('');
                    setPrepaidCost('');
                    setAdvancePrepaidPopupOpen(true);
                  }}
                >
                  {t('lblAdvancePrepaidWorkOrder', 'Advance / Prepaid Work Order')}
                </Button>
              )}
            </div>
          ) : SessionUser.TenantId === 9 ? (
            <div>
              <Button
                variant="contained"
                color="primary"
                className={classes.submitButton}
                onClick={() => setReferenceWorkOrderOpen(true)}
              >
                {t('lblReferenceWorkOrder')}
              </Button>
              <Button
                variant="contained"
                color="primary"
                className={classes.submitButton}
                onClick={() => handleOpenApproval(1)}
              >
                {t('lblQuotationWorkOrder')}
              </Button>
            </div>
          ) : (
            <div>
              <Button
                variant="contained"
                color="primary"
                className={classes.submitButton}
                onClick={() => handleOpenApproval(2)}
              >
                {t('lblExpenseWorkOrder')}
              </Button>
              <Button
                variant="contained"
                color="primary"
                className={classes.submitButton}
                onClick={() => handleOpenApproval(1)}
              >
                {t('lblQuotationWorkOrder')}
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={() => { setSubstitutionPopup(true) }}
                endIcon={<FindReplaceIcon />}
                className={classes.submitButton}
                disabled={
                  (FirstType == 16 || FirstType == 17) && (FirstIssueType != 1) ? true : false
                }
              >
                {t('lblSubstitution')}
              </Button>
              <Button
                variant="contained"
                color="secondary"
                className={classes.submitButton}
                onClick={() => setSoftwareDownloadOpen(true)}
                endIcon={<DeveloperBoardIcon />}
              >
                {t('lblBonaDataCollection')}
              </Button>
              <Button
                variant="contained"
                color="secondary"
                className={classes.submitButton}
                onClick={() => GetBonaPdfData()}
                endIcon={<PictureAsPdfIcon />}
              >
                {t('lblBonaDataPdf')}
              </Button>
            </div>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setCopyWorkOrderPopup(false)} color="primary">
            {t('Tamam')}
          </Button>
        </DialogActions>
      </Dialog>
      {/* -------Advance / Prepaid Work Order Dialog-------- */}
      <Dialog
        open={advancePrepaidPopupOpen}
        onClose={() => setAdvancePrepaidPopupOpen(false)}
        aria-labelledby="advance-prepaid-dialog-title"
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle id="advance-prepaid-dialog-title" color="primary">
          <Typography variant="h5" component="h2">
            {t('lblAdvancePrepaidWorkOrder', 'Advance / Prepaid Work Order')}
          </Typography>
        </DialogTitle>
        <Divider />
        <DialogContent>
          <Grid container spacing={2} style={{ marginTop: '8px' }}>
            <Grid item xs={12}>
              <TextField
                size="small"
                fullWidth
                select
                label={t('Tahsilat_Tipi', 'Payment Type')}
                value={prepaidPaymentTypeId}
                onChange={(e) => setPrepaidPaymentTypeId(e.target.value)}
                variant="outlined"
              >
                {activePaymentTypeData &&
                  activePaymentTypeData.map((p) => (
                    <MenuItem key={p.Id} value={p.Id}>
                      {p.Dsc}
                    </MenuItem>
                  ))}
              </TextField>
            </Grid>
            <Grid item xs={12}>
              <TextField
                size="small"
                fullWidth
                label={t('lblCost', 'Cost')}
                type="number"
                value={prepaidCost}
                onChange={(e) => setPrepaidCost(e.target.value)}
                variant="outlined"
                inputProps={{ min: 0, step: "0.01" }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      {SessionUser?.CurrencyUnit || 'PKR'}
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setAdvancePrepaidPopupOpen(false)}
            color="primary"
            disabled={isSubmittingPrepaid}
          >
            {t('iptal', 'Cancel')}
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleCreateAdvancePrepaidWorkOrder}
            disabled={
              isSubmittingPrepaid ||
              !prepaidPaymentTypeId ||
              !prepaidCost ||
              parseFloat(prepaidCost) <= 0
            }
          >
            {isSubmittingPrepaid ? (
              <CircularProgress size={20} color="inherit" />
            ) : (
              t('lblCreate', 'Create')
            )}
          </Button>
        </DialogActions>
      </Dialog>
      {/* --------------------- */}
      <Dialog
        open={PrintPopup}
        onClose={() => setPrintPopup(false)}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent>
          <Print ReceiptNo={ReceiptNo} ReadOnly={false} />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setPrintPopup(false)} color="primary">
            {t('Tamam')}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={FollowPopup}
        onClose={() => setFollowPopup(false)}
      >
        <DialogContent>
          <Follow ReceiptNo={ReceiptNo} />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setFollowPopup(false)} color="primary">
            {t('Tamam')}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={ClosePopupControl}
        onClose={
          () => {
            setClosePopupControl(false)
            clearUnusedItemsCheckBox()
          }
        }
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">
          <Typography variant="h5" component="h2">
            {ClosePopupHeader}
          </Typography>
        </DialogTitle>
        <DialogActions>
          <Button
            variant="contained"
            onClick={(event) => {
              handleMerkezeGonderEvet(event, CloseTypePopupControl1)
              clearUnusedItemsCheckBox()
            }}
            color="primary"
            disabled={isButtonDisabled3}
          >
            {CloseBtn1}
          </Button>
          <Button
            variant="contained"
            onClick={(event) => {
              handleMerkezeGonderEvet(event, CloseTypePopupControl2)
              clearUnusedItemsCheckBox()
            }}
            color="primary"
            disabled={isButtonDisabled3}
          >
            {CloseBtn2}
          </Button>
        </DialogActions>
      </Dialog>
      {/* -------Reference Work Order-------- */}
      <Dialog
        open={ReferenceWorkOrderOpen}
        onClose={() => setReferenceWorkOrderOpen(false)}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent>
          <Card>
            <CardHeader title={t('lblReferenceWorkOrder')} />
            <Divider />
            <CardContent>
              <Grid container spacing={1}>
                {parseInt(SessionUser.TenantId) !== 75 && (
                  <>
                    <Grid item xs={12} sm={12} lg={12}>
                      <Autocomplete
                        size="small"
                        fullWidth
                        autoSelect
                        disableClearable
                        value={ServiceShopSelected || null}
                        options={ServiceShopData || []}
                        getOptionLabel={(option) => (option.Dsc ? option.Dsc : '')}
                        getOptionSelected={(option, value) => option.Id === value.Id}
                        renderInput={(params) => <TextField {...params} label={t('lblServiceShop')} variant="outlined"
                        />}
                        onChange={(event, value) => { handleChangeServiceShopId(value); }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={12} lg={12}>
                      <TextField
                        size="small"
                        fullWidth
                        select
                        label={t('lblEmployee')}
                        id="EmployeeId"
                        onChange={handleChangeEmployeeId}
                        value={EmployeeId}
                        variant="outlined"
                      >
                        {EmployeeData.map(p => {
                          return (
                            <MenuItem key={p.Id} value={p.Id}>
                              {p.Dsc}
                            </MenuItem>
                          );
                        })}
                      </TextField>
                    </Grid>
                  </>
                )}
                <Grid item xs={12} sm={12} lg={12}>
                  <AppReasonSearch
                    setIssue={handleChangeIssueId}
                    value={
                      {
                        Dsc: newWorkCaseData.Issue || '',
                        Id: newWorkCaseData.IssueId || 0
                      } || ''
                    }
                    searchParam={search}
                  />
                </Grid>
              </Grid>
            </CardContent>
            <div className={classes.wrapper}>
              <Button
                variant="contained"
                color="primary"
                className={classes.submitButton}
                onClick={() => handleOpenApproval(0)}
                endIcon={<AddBoxRoundedIcon fontSize="small" />}
                style={{ backgroundColor: FisHeader[0].Follow === 1 ? green[500] : '' }}
              >
                {t('lblCreate')}
              </Button>
            </div>
          </Card>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setReferenceWorkOrderOpen(false)} color="primary">
            {t('Tamam')}
          </Button>
        </DialogActions>
      </Dialog>
      {/* --------------------- */}
      <Dialog
        fullWidth
        maxWidth="sm"
        onClose={handleCloseCancellationPopup}
        aria-labelledby="customized-dialog-title"
        open={openCancellationPopup}
      >
        <DialogTitle
          id="customized-dialog-title"
          onClose={handleCloseCancellationPopup}
        ></DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={1}>
            <Grid item xs={12} sm={12} lg={12}>
              <Autocomplete
                size="small"
                fullWidth
                autoSelect
                disableClearable
                value={CancellationReasonId || ''}
                options={cancellationReasonsData || []}
                getOptionLabel={option => (option.MainLanguageDescription ? option.MainLanguageDescription : '')}
                getOptionSelected={(option, value) => option.Id === value.Id}
                renderInput={params => (
                  <TextField
                    {...params}
                    label={t('lblCancellationReason')}
                    variant="outlined"
                  />
                )}
                onChange={(event, value) => {
                  setCancellationReasonId(value);
                }}
              />
            </Grid>
            <Grid item xs={12} sm={12} lg={12}>
              <TextField
                size="small"
                id="desc"
                autoComplete="no"
                multiline
                rows={10}
                value={CancellationNote}
                onChange={event => setCancellationNote(event.target.value)}
                fullWidth
                label={t('lblCancellationNote')}
                variant="outlined"
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="primary"
            onClick={() => SaveCancellation(8)}
            aria-label="save"
            disabled={CancellationNote.length === 0 || CancellationReasonId.Id === 0}
            component="span"
            endIcon={<SaveIcon />}
          >
            {t('lblSave')}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={OpenResponse}
        onClose={() => setOpenResponse(false)}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">
          {t('Bilgilendirme')}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <List dense={false}>
              {ResponseData.map((item, index) => (
                <ListItem key={index}>
                  <ListItemText
                    primary={item}
                  />
                </ListItem>
              ))}
            </List>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenResponse(false)} color="primary">
            {t('Tamam')}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={OpenMaterialOrder}
        fullWidth={true}
        maxWidth={'xl'}
        onClose={handleCloseDialog}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent>
          <ForPartner MaterialOrderIdPopup={MaterialOrderId} onCancel={() => { isCancelledRef.current = true; }} onSapSent={() => { isCancelledRef.current = true; }} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialog} color="primary">
            {t('Tamam')}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={OpenTriageMaterialOrder}
        fullWidth={true}
        maxWidth={'xl'}
        onClose={() => handleCloseTriageMaterialOrder()}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent>
          <TriageMaterialOrder
            MaterialIds={matchedPairs.map(p => p.material?.MaterialId)}
            WorkOrderId={ReceiptNo.includes(" ") ? ReceiptNo.trim() : ReceiptNo}
            ServiceShopId={SonlandirData[0]?.ServiceShopId}
            getOrderNr={getOrderNr}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleCloseTriageMaterialOrder()} color="primary">
            <CloseIcon />
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={OpenUsedNotUsedDialog}
        fullWidth={true}
        maxWidth={'md'}
        onClose={() => { setOpenUsedNotUsedDialog(false); clearUnusedItemsCheckBox() }}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent>
          {error && <Grid item xs={6} md={12} style={{ backgroundColor: "#1d3343", padding: "6px 14px" }}>
            <Typography variant="h6" gutterBottom style={{ color: "white" }}>
              You have to select all items!
            </Typography>
          </Grid>}

          <TableContainer className={classes.container}>
            <Table stickyHeader aria-label="sticky table" size="small">
              <TableHead>
                <TableRow>
                  <TableCell align="left">Defect Name</TableCell>
                  <TableCell align="left">Material </TableCell>
                  <TableCell align="left">Used</TableCell>
                  <TableCell align="left">Not Used</TableCell>
                </TableRow>
              </TableHead>
              {cloneArray?.map((row, index) => {
                return (<TableRow key={index}>
                  <TableCell align="left">
                    <Typography>
                      {row?.DefectDesc}
                    </Typography>
                  </TableCell>
                  <TableCell align="left">
                    <Typography>
                      {row.MaterialCode} - {row.MaterialDesc}
                    </Typography>
                  </TableCell>
                  <TableCell align="left">
                    <FormControlLabel control={<Checkbox checked={row.is_selected} onChange={(e) => { checkSelection({ index, value: true, id: row.MaterialId }) }} />} />
                  </TableCell>
                  <TableCell align="left">
                    <FormControlLabel control={<Checkbox checked={row.is_selected !== null && !row.is_selected} onChange={(e) => { checkSelection({ index, value: false, id: row.MaterialId }) }} />} /></TableCell>
                </TableRow>)
              })}
            </Table>
          </TableContainer>

        </DialogContent>
        <DialogActions>
          <Button onClick={() => { setOpenUsedNotUsedDialog(false); clearUnusedItemsCheckBox() }} color="primary">
            Cancel {/* {t('Tamam')} */}
          </Button>
          <Button onClick={() => handleSelectedUnusedItems()} color="primary">
            {t('Tamam')}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={SubstitutionPopup}
        onClose={handleClose}
      >
        <DialogContent>
          <Substitution ReceiptNo={ReceiptNo} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}
            color="primary"
          >
            {t('Tamam')}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={OpenAIDialog}
        onClose={() => setOpenAIDialog(false)}
        fullWidth
        maxWidth="xl"
        style={{ width: '100%', height: '100%' }}
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">
          {t('lblAIPredictions')}
        </DialogTitle>
        <DialogContent>
          <React.Fragment>
            <Grid container spacing={2}>
              <Grid item xs={5}>
                <Typography variant="h6">{t('lblDefects')}</Typography>
                {defectsAndMaterials.map((defect, index) => (
                  defect.DefectCode && defect.Defect && (
                    <Paper key={index} style={{ padding: '10px', marginBottom: '10px' }}>
                      <Grid container spacing={2} alignItems="center">
                        <Grid item xs={8}>
                          <Typography>{`${defect.CategoryLevel2 + ', ' + defect.DefectType + ' - ' + defect.Defect}`}</Typography>
                        </Grid>
                        <Grid item xs={4} style={{ textAlign: 'right' }}>
                          <FormControlLabel
                            control={<Checkbox color="primary" />}
                            label=""
                            checked={selectedDefect === defect}
                            onChange={() => handleDefectSelect(defect)}
                          />
                        </Grid>
                      </Grid>
                    </Paper>
                  )
                ))}
              </Grid>
              <Grid item xs={2}>
                {/* Match button */}
                <Grid container spacing={2} direction="column" alignItems="center">
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleMatch}
                    disabled={!selectedDefect || !selectedMaterial}
                  >
                    {t('lblMatch')}
                  </Button>
                </Grid>
              </Grid>
              <Grid item xs={5} style={{ flexBasis: '40%' }}>
                <Typography variant="h6">{t('lblMaterials')}</Typography>
                {defectsAndMaterials.map((material, index) => (
                  material.MaterialCode && material.MaterialDsc && (
                    <Paper key={index} style={{ padding: '10px', marginBottom: '10px' }}>
                      <Grid container spacing={2} alignItems="center">
                        <Grid item xs={8}>
                          <Typography>{`${material.MaterialCode}-${material.MaterialDsc}`}</Typography>
                        </Grid>
                        <Grid item xs={4} style={{ textAlign: 'right' }}>
                          <FormControlLabel
                            control={<Checkbox color="primary" />}
                            label=""
                            checked={selectedMaterial === material && selectedDefect}
                            onChange={() => handleMaterialSelect(material)}
                            disabled={matchedPairs.some(pair => pair.material?.MaterialCode === material.MaterialCode) || !selectedDefect}
                          />
                        </Grid>
                      </Grid>
                    </Paper>
                  )
                ))}
              </Grid>
            </Grid>
            <Grid item xs={12} sm={12} lg={12}>
              <Card>
                <Hizmet matchedPairsArray={matchedPairs ? matchedPairs : []} handleAddMatchedPairs={handleAddMatchedPairs} ReceiptNo={ReceiptNo} readonly={false} />
              </Card>
            </Grid>
            <Divider style={{ margin: '20px 0' }} />
            <Typography variant="h6">{t('lblAlreadyUsed')}</Typography>
            {defectAndMaterialList.map((pair, index) => (
              <React.Fragment key={index}>
                <Grid container alignItems="center">
                  <Grid item xs={1}>
                    <ChevronRightIcon />
                  </Grid>
                  <Grid item xs={9}>
                    <Typography>{pair ? `${pair.Defect} | ${pair.Material}` : ''}</Typography>
                  </Grid>
                </Grid>
              </React.Fragment>
            ))}
            <Divider style={{ margin: '20px 0' }} />
            <Typography variant="h6">{t('lblMatches')}</Typography>
            {matchedPairs.map((pair, index) => (
              <React.Fragment key={index}>
                <Grid container alignItems="center">
                  <Grid item xs={1}>
                    <ChevronRightIcon />
                  </Grid>
                  <Grid item xs={9}>
                    <Typography>{pair.material ? `${pair.defect.DefectCode}-${pair.defect.Defect} | ${pair.material?.MaterialCode}-${pair.material?.MaterialDsc}` : `${pair.defect.DefectCode}-${pair.defect.Defect}`}</Typography>
                  </Grid>
                  <Grid item xs={2} style={{ textAlign: 'right' }}>
                    <IconButton onClick={() => handleDeleteMatchedPair(index)}>
                      <DeleteIcon style={{ color: '#9B4444' }} />
                    </IconButton>
                  </Grid>
                </Grid>
              </React.Fragment>
            ))}
            <Divider style={{ margin: '20px 0' }} />
            <Grid container spacing={2} justify="center">
              <Grid item>
                <Tooltip title={t('lblWithoutOrderTip')} arrow>
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<RemoveShoppingCartIcon />}
                    endIcon={<span style={{ width: 20 }} />}
                    style={{ backgroundColor: '#8CB9BD' }}
                    onClick={() => TriagePreorderOperations(false)}
                  >
                    <span style={{ margin: '0 auto' }}>{t('lblWithoutOrder')}</span>
                  </Button>
                </Tooltip>
              </Grid>
              <Grid item>
                <Tooltip title={t('lblSaveAndOrder')} arrow>
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<SaveIcon />}
                    endIcon={<ShoppingCartIcon />}
                    style={{ backgroundColor: '#344955' }}
                    disabled={!hasMaterialAndDefect}
                    onClick={() => {
                      TriagePreorderOperations(true)
                      setOpenTriageMaterialOrder(true)
                    }}
                  >
                    <span style={{ margin: '0 auto' }}>{t('lblSaveAndOrderHeader')}</span>
                  </Button>
                </Tooltip>
              </Grid>
            </Grid>
          </React.Fragment>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="primary"
            endIcon={<CloseIcon />}
            style={{ backgroundColor: '#344955' }}
            onClick={() => setOpenAIDialog(false)}
          >
            <span style={{ margin: '0 auto' }}>{t('lblCancel')}</span>
          </Button>
        </DialogActions>
        <Backdrop open={LoadingControl} style={{ zIndex: 1000 }}>
          <CircularProgress color="inherit" />
        </Backdrop>
      </Dialog>
      {/* --------Bona-------- */}
      <Dialog
        open={SoftwareDownloadOpen}
        onClose={() => setSoftwareDownloadOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullScreen
      >
        <DialogTitle id="alert-dialog-title">
          {t('lblBonaDataCollection')}
          <Divider />
        </DialogTitle>

        <DialogContent>
          <Stepper
            activeStep={activeStep}
            orientation="vertical"
          >
            {steps.map((label, index) => (
              <Step key={label}>
                <StepLabel classes={{ iconContainer: classes.stepIcon }}>{label}</StepLabel>
                <StepContent>
                  <br />
                  <br />
                  {getStepContent(index)}
                  <br />
                  <br />
                  <div className={classes.actionsContainer}>
                    <div>
                      <Button
                        disabled={activeStep === 0}
                        variant="contained"
                        onClick={handleBack}
                        startIcon={<KeyboardArrowLeft />}
                        className={classes.button}
                        style={{
                          backgroundColor: activeStep === 0 ? "#D3D3D3" : "#B6A28E",
                          color: activeStep === 0 ? "#A9A9A9" : "white",
                        }}
                      >
                        {t('lblBack')}
                      </Button>

                      <Button
                        variant="contained"
                        style={{ backgroundColor: "#685752", color: "white" }}
                        onClick={handleNext}
                        endIcon={<KeyboardArrowRight />}
                        className={classes.button}
                      >
                        {activeStep === steps.length - 1 ? t('lblInstall') : t('lblNext')}
                      </Button>
                    </div>
                  </div>
                </StepContent>
              </Step>
            ))}
          </Stepper>
          {activeStep === steps.length && (
            <Paper square elevation={0} className={classes.resetContainer}>
              <Typography>{response}</Typography>
              <Button onClick={handleReset} className={classes.button}>
                {t('lblReset')}
              </Button>
            </Paper>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            style={{ backgroundColor: "#B6A28E", color: "white" }}
            onClick={() => setSoftwareDownloadOpen(false)}
            className={classes.submitButtonWudaq}
            endIcon={<CloseIcon>Close</CloseIcon>}
          >
            {t('lblClose')}
          </Button>

        </DialogActions>
      </Dialog>
      <BarkodPopup onClose={handleCihazBarkodClose} open={OpenBarkodCihaz} ScanTime={1000} />
      {/* --------------------*/}
      <ErrorDialog open={openErrorDialog} onClose={() => setOpenErrorDialog(false)} message={messageErrorDialog} />
    </Grid>
  );
}


export default connect(state =>
({
  tasks: state.tasks1,
  defectReducer: state.defectReducer,
  labourReducer: state.labourReducer,
  materialReducer: state.materialReducer
})
  , { setTask, getTasksRequest })(
    Header
  );
